import { DatePill } from './DatePill';
import { useDataRefresh } from '../../context/DataRefreshContext';
import { useAuth } from '../../hooks/useAuth';
import { useTheme } from '../../context/ThemeContext';

export function Header({ title, onMenu }) {
  const { refresh } = useDataRefresh();
  const { logout } = useAuth();
  const { dark, toggle } = useTheme();
  return (
    <header className="flex items-center justify-between gap-3 px-4 sm:px-6 py-4 bg-white/60 dark:bg-slate-900/60 backdrop-blur-xl border-b border-white/50 dark:border-white/10 sticky top-0 z-30">
      <div className="flex min-w-0 items-center gap-2">
        {/* Hamburger — mobile only */}
        <button
          type="button"
          onClick={onMenu}
          aria-label="Open menu"
          className="lg:hidden -ml-1 p-2 rounded-lg text-slate-600 dark:text-slate-300 hover:bg-slate-100 dark:hover:bg-white/10 transition-colors"
        >
          <svg className="w-6 h-6" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true">
            <path strokeLinecap="round" d="M4 6h16M4 12h16M4 18h16" />
          </svg>
        </button>
        <h1 className="truncate text-lg sm:text-xl font-semibold text-navy-800 dark:text-slate-100">{title}</h1>
      </div>
      <div className="flex shrink-0 items-center gap-2">
        {/* Today's date — opens a calendar popover */}
        <DatePill />

        {/* Theme toggle */}
        <button
          type="button"
          onClick={toggle}
          title={dark ? 'Switch to light mode' : 'Switch to dark mode'}
          aria-label={dark ? 'Switch to light mode' : 'Switch to dark mode'}
          className="p-2 rounded-lg text-slate-500 dark:text-slate-300 hover:bg-slate-100 dark:hover:bg-white/10 hover:text-brand transition-colors"
        >
          {dark ? (
            <svg className="w-5 h-5" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.6" aria-hidden="true">
              <circle cx="10" cy="10" r="3.5" />
              <path strokeLinecap="round" d="M10 2v2M10 16v2M2 10h2M16 10h2M4.2 4.2l1.4 1.4M14.4 14.4l1.4 1.4M15.8 4.2l-1.4 1.4M5.6 14.4l-1.4 1.4" />
            </svg>
          ) : (
            <svg className="w-5 h-5" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.6" aria-hidden="true">
              <path strokeLinecap="round" strokeLinejoin="round" d="M16.5 11.5A6.5 6.5 0 018.5 3.5a6.5 6.5 0 108 8z" />
            </svg>
          )}
        </button>

        <button
          type="button"
          onClick={refresh}
          title="Refresh data"
          aria-label="Refresh data"
          className="p-2 rounded-lg text-slate-500 dark:text-slate-300 hover:bg-slate-100 dark:hover:bg-white/10 hover:text-brand transition-colors"
        >
          <svg className="w-5 h-5" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.6" aria-hidden="true">
            <path strokeLinecap="round" strokeLinejoin="round" d="M15.5 8A5.5 5.5 0 006 5.5L4 7.5M4.5 12A5.5 5.5 0 0014 14.5l2-2M4 4v3.5h3.5M16 16v-3.5h-3.5" />
          </svg>
        </button>

        {/* Logout */}
        <button
          type="button"
          onClick={logout}
          className="flex items-center gap-1.5 rounded-full bg-red-50 dark:bg-red-500/15 px-3 py-1.5 text-sm font-medium text-red-600 dark:text-red-300 ring-1 ring-red-200 dark:ring-red-500/30 hover:bg-red-100 dark:hover:bg-red-500/25 transition-colors"
        >
          <svg className="h-4 w-4" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.6" aria-hidden="true">
            <path strokeLinecap="round" strokeLinejoin="round" d="M13 7V4a1 1 0 00-1-1H5a1 1 0 00-1 1v12a1 1 0 001 1h7a1 1 0 001-1v-3M9 10h9m0 0l-3-3m3 3l-3 3" />
          </svg>
          <span className="hidden sm:inline">Logout</span>
        </button>
      </div>
    </header>
  );
}
